export const GRADIENT_PROGRESS_BAR_DIRECTION_NAMES = {
    REVERSE: 'reverse',
    NORMAL: 'normal',
} as const;